<template>
  <Tippy
    ref="popover"
    :arrow="true"
    trigger="click"
    interactive
    theme="light"
    placement="bottom"
  >
    <template #trigger>
      <div class="sort-option-selected">
        <div
          class="font-weight-bold text-secondary"
          style="font-size: 10px; min-width: 180px"
        >
          {{ $t('bankStatements.transferStatus') }}
        </div>
        <div
          style="font-size: 14px"
        >
          {{ selectedText }}
        </div>
      </div>
    </template>

    <div style="min-width: 180px">
      <div
        v-for="(k, i) in options"
        :key="k.key"
        class="sort-option text-left"
        :class="{ first: i === 0, active: selected === k.key }"
        @click="select(k.key)"
      >
        {{ k.text }}
      </div>
    </div>
  </Tippy>
</template>

<script>
export default {
  props: {
    selected: String,
  },
  computed: {
    selectedText() {
      return this.options.find((x) => x.key === this.selected)?.text;
    },
    options() {
      return [
        {
          key: 'Unspecified',
          text: this.$t('billingPlan.select.all'),
        },
        {
          key: 'Unsettled',
          text: this.$t('bankStatements.statuses.unsettled'),
        },
      ];
    },
  },
  methods: {
    select(key) {
      this.$emit('update:selected', key);
      this.$refs.popover.tippy().hide();
    },
  },
};
</script>

<style lang="scss" scoped>
 @import "../payers/style.scss";
</style>
